module.exports = __webpack_public_path__ + "static/img/static/img/pre_down.838b5aeb.png";